"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.checkBookingTags = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _DataStore = _interopRequireWildcard(require("../KESI2/Stores/DataStore2"));

var _KESI2Helper = _interopRequireDefault(require("../KESI2/KESI2Helper"));

var _RegisterInstance = _interopRequireDefault(require("../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../utils/HttpRequest");

var _BuildConstants = require("../utils/BuildConstants");

var _DrupalEventSeries = require("../common/components/DrupalTiles/DrupalEventSeries");

var _DrupalEventDate = require("../common/components/DrupalTiles/DrupalEventDate");

var _ArrayHelper = require("./ArrayHelper");

function asyncForEach(_x, _x2) {
  return _asyncForEach.apply(this, arguments);
}

function _asyncForEach() {
  _asyncForEach = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(array, callback) {
    var index;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            index = 0;

          case 1:
            if (!(index < array.length)) {
              _context7.next = 7;
              break;
            }

            _context7.next = 4;
            return callback(array[index], index, array);

          case 4:
            index++;
            _context7.next = 1;
            break;

          case 7:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _asyncForEach.apply(this, arguments);
}

var checkBookingTags = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var loggedIn, token, response, allBookings;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            console.log('check booking tags start');
            loggedIn = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.LOGGED_IN);

            if (loggedIn) {
              _context6.next = 4;
              break;
            }

            return _context6.abrupt("return");

          case 4:
            _context6.prev = 4;
            _context6.next = 7;
            return _RegisterInstance["default"].getAccessToken('course:read');

          case 7:
            token = _context6.sent;
            _context6.next = 10;
            return (0, _HttpRequest.httpGet)("".concat(_BuildConstants.SEMINARS_HOST, "/").concat(_DrupalEventSeries.GET_EVENT_SERIES_DETAILS_URL), {}, null, null, 10, 'Bearer ' + token);

          case 10:
            response = _context6.sent;
            allBookings = response.data;

            if (allBookings) {
              (0, _keys["default"])(allBookings).forEach(function (eventSeriesUuid) {
                var eventDates = allBookings[eventSeriesUuid];

                if (eventDates) {
                  var synchronize = /*#__PURE__*/function () {
                    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
                      return _regenerator["default"].wrap(function _callee5$(_context5) {
                        while (1) {
                          switch (_context5.prev = _context5.next) {
                            case 0:
                              asyncForEach((0, _keys["default"])(eventDates), /*#__PURE__*/function () {
                                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(eventDateUuid) {
                                  var bookingState, eventDateContent, state, bookings, bookedIndex, tagArray, _bookings, _bookedIndex, _tagArray, _bookings2, _bookedIndex2, eventSeries, _tagArray2;

                                  return _regenerator["default"].wrap(function _callee4$(_context4) {
                                    while (1) {
                                      switch (_context4.prev = _context4.next) {
                                        case 0:
                                          bookingState = eventDates[eventDateUuid];

                                          if (!bookingState) {
                                            _context4.next = 33;
                                            break;
                                          }

                                          eventDateContent = _KESI2Helper["default"].getEventDateByUuid(eventDateUuid);

                                          if (eventDateContent) {
                                            _context4.next = 5;
                                            break;
                                          }

                                          return _context4.abrupt("return");

                                        case 5:
                                          state = bookingState.state;
                                          console.log('BookingHelper, bookingState', bookingState, eventDateContent, state);

                                          if (!(state === _DrupalEventDate.BOOKING_STATES.BOOKED)) {
                                            _context4.next = 15;
                                            break;
                                          }

                                          if (!eventDateContent.id) {
                                            _context4.next = 14;
                                            break;
                                          }

                                          bookings = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES) || [];
                                          bookedIndex = bookings.indexOf(eventDateContent.id);

                                          if (!(bookedIndex < 0)) {
                                            _context4.next = 14;
                                            break;
                                          }

                                          _context4.next = 14;
                                          return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES, bookings.concat(eventDateContent.id));

                                        case 14:
                                          if (eventDateContent.bookingTags) {
                                            tagArray = eventDateContent.bookingTags.split(',');
                                            tagArray.forEach( /*#__PURE__*/function () {
                                              var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(singleTag) {
                                                var storedTags, index, storedMobileTags, mobileIndex;
                                                return _regenerator["default"].wrap(function _callee$(_context) {
                                                  while (1) {
                                                    switch (_context.prev = _context.next) {
                                                      case 0:
                                                        storedTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS) || [];
                                                        index = storedTags.indexOf(singleTag);
                                                        console.log('BookingHelper', storedTags, index);
                                                        storedMobileTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS) || [];
                                                        mobileIndex = storedMobileTags.findIndex(function (tag) {
                                                          return tag.name === singleTag;
                                                        });
                                                        console.log('checking booking tags, got event data (BOOKED)', storedTags, index, storedMobileTags, mobileIndex);

                                                        if (!(index < 0)) {
                                                          _context.next = 11;
                                                          break;
                                                        }

                                                        console.log('checking booking tags, storing booking tags (BOOKED)');
                                                        _context.next = 10;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS, storedTags.concat(singleTag));

                                                      case 10:
                                                        console.log('checking booking tags, done storing booking tags (BOOKED)');

                                                      case 11:
                                                        if (!(mobileIndex < 0)) {
                                                          _context.next = 14;
                                                          break;
                                                        }

                                                        _context.next = 14;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS, storedMobileTags.concat({
                                                          name: singleTag
                                                        }));

                                                      case 14:
                                                      case "end":
                                                        return _context.stop();
                                                    }
                                                  }
                                                }, _callee);
                                              }));

                                              return function (_x4) {
                                                return _ref4.apply(this, arguments);
                                              };
                                            }());
                                          }

                                        case 15:
                                          if (!(state === _DrupalEventDate.BOOKING_STATES.CANCELED)) {
                                            _context4.next = 24;
                                            break;
                                          }

                                          if (!eventDateContent.id) {
                                            _context4.next = 23;
                                            break;
                                          }

                                          _bookings = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES) || [];
                                          _bookedIndex = _bookings.indexOf(eventDateContent.id);

                                          if (!(_bookedIndex > -1)) {
                                            _context4.next = 23;
                                            break;
                                          }

                                          (0, _ArrayHelper.removeElementAtPosition)(_bookings, _bookedIndex);
                                          _context4.next = 23;
                                          return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES, _bookings);

                                        case 23:
                                          if (eventDateContent.bookingTags) {
                                            _tagArray = eventDateContent.bookingTags.split(',');

                                            _tagArray.forEach( /*#__PURE__*/function () {
                                              var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(singleTag) {
                                                var storedTags, index, storedMobileTags, mobileIndex;
                                                return _regenerator["default"].wrap(function _callee2$(_context2) {
                                                  while (1) {
                                                    switch (_context2.prev = _context2.next) {
                                                      case 0:
                                                        storedTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS) || [];
                                                        index = storedTags.indexOf(singleTag);
                                                        storedMobileTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS) || [];
                                                        mobileIndex = storedMobileTags.findIndex(function (tag) {
                                                          return tag.name === singleTag;
                                                        });
                                                        console.log('checking booking tags, got event data (CANCELED)', storedTags, index, storedMobileTags, mobileIndex);

                                                        if (!(index > -1)) {
                                                          _context2.next = 11;
                                                          break;
                                                        }

                                                        (0, _ArrayHelper.removeElementAtPosition)(storedTags, index);
                                                        console.log('checking booking tags, storing booking tags (CANCELED)');
                                                        _context2.next = 10;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKING_TAGS, storedTags);

                                                      case 10:
                                                        console.log('checking booking tags, done storing booking tags (CANCELED)');

                                                      case 11:
                                                        if (!(mobileIndex > -1)) {
                                                          _context2.next = 17;
                                                          break;
                                                        }

                                                        (0, _ArrayHelper.removeElementAtPosition)(storedMobileTags, mobileIndex);
                                                        console.log('checking mobile booking tags, storing booking tags (CANCELED)', storedMobileTags);
                                                        _context2.next = 16;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.MOBILE_BOOKING_TAGS, storedMobileTags);

                                                      case 16:
                                                        console.log('checking mobile booking tags, done storing booking tags (CANCELED)');

                                                      case 17:
                                                      case "end":
                                                        return _context2.stop();
                                                    }
                                                  }
                                                }, _callee2);
                                              }));

                                              return function (_x5) {
                                                return _ref5.apply(this, arguments);
                                              };
                                            }());
                                          }

                                        case 24:
                                          if (!(state === _DrupalEventDate.BOOKING_STATES.FINISHED)) {
                                            _context4.next = 33;
                                            break;
                                          }

                                          if (!eventDateContent.id) {
                                            _context4.next = 31;
                                            break;
                                          }

                                          _bookings2 = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES) || [];
                                          _bookedIndex2 = _bookings2.indexOf(eventDateContent.id);

                                          if (!(_bookedIndex2 < 0)) {
                                            _context4.next = 31;
                                            break;
                                          }

                                          _context4.next = 31;
                                          return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.BOOKED_EVENT_DATES, _bookings2.concat(eventDateContent.id));

                                        case 31:
                                          eventSeries = _KESI2Helper["default"].getEventSeriesByEventDateId(eventDateContent.id);

                                          if (eventSeries.completionTags) {
                                            _tagArray2 = eventSeries.completionTags.split(',');

                                            _tagArray2.forEach( /*#__PURE__*/function () {
                                              var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(singleTag) {
                                                var storedTags, index, storedMobileTags, mobileIndex;
                                                return _regenerator["default"].wrap(function _callee3$(_context3) {
                                                  while (1) {
                                                    switch (_context3.prev = _context3.next) {
                                                      case 0:
                                                        storedTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.COMPLETION_TAGS) || [];
                                                        index = storedTags.indexOf(singleTag);
                                                        storedMobileTags = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.MOBILE_COMPLETION_TAGS) || [];
                                                        mobileIndex = storedMobileTags.findIndex(function (tag) {
                                                          return tag.name === singleTag;
                                                        });
                                                        console.log('checking completion tags, got event data', storedTags, index, storedMobileTags, mobileIndex);

                                                        if (!(index < 0)) {
                                                          _context3.next = 10;
                                                          break;
                                                        }

                                                        console.log('checking completion tags, storing finished tags (FINISHED)', storedTags, storedTags.concat(singleTag));
                                                        _context3.next = 9;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.COMPLETION_TAGS, storedTags.concat(singleTag));

                                                      case 9:
                                                        console.log('checking completion tags, done storing finished tags (FINISHED)');

                                                      case 10:
                                                        if (!(mobileIndex < 0)) {
                                                          _context3.next = 13;
                                                          break;
                                                        }

                                                        _context3.next = 13;
                                                        return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.MOBILE_COMPLETION_TAGS, storedMobileTags.concat({
                                                          name: singleTag
                                                        }));

                                                      case 13:
                                                      case "end":
                                                        return _context3.stop();
                                                    }
                                                  }
                                                }, _callee3);
                                              }));

                                              return function (_x6) {
                                                return _ref6.apply(this, arguments);
                                              };
                                            }());
                                          }

                                        case 33:
                                        case "end":
                                          return _context4.stop();
                                      }
                                    }
                                  }, _callee4);
                                }));

                                return function (_x3) {
                                  return _ref3.apply(this, arguments);
                                };
                              }());

                            case 1:
                            case "end":
                              return _context5.stop();
                          }
                        }
                      }, _callee5);
                    }));

                    return function synchronize() {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  synchronize();
                }
              });
            }

            _context6.next = 18;
            break;

          case 15:
            _context6.prev = 15;
            _context6.t0 = _context6["catch"](4);
            console.log('error getting booking states', _context6.t0);

          case 18:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[4, 15]]);
  }));

  return function checkBookingTags() {
    return _ref.apply(this, arguments);
  };
}();

exports.checkBookingTags = checkBookingTags;